import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import uuid from "react-uuid";
import {
  Grid, Typography, Box, TextField, Button,
  FormControl, FormLabel, RadioGroup,
  FormControlLabel, Radio, Chip, Avatar,
  Link, Snackbar
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@material-ui/core/styles';
import WwDatePicker from "../../Components/Modal/WwDatePicker";
import Confirmation from "./../../Components/Modal/Confirmation";
import DropdownComponent from "./../../Components/UI/DropdownComponent";

import { getClassNames, generateRandomId, joinByKeys } from "../../Js/Common";
import { nameToJson } from "../Profile/Services";
import { fetchUserByUid, createUser, updateUsersAction } from './Services';
import { validator } from "../../Js/Validator";
import { userLogs } from "../../Js/Common";


const userObj = {
  "name": "",
  "designation": "",
  "contact_details": { "cdetails": { "email": [], "phone": [], "email_notification_flag": false } },
  "joining_date": null,
  "birthday": null,
  "belongs_to": "",
  "gender": "Other",
  "role_uid": ""
};

const UserProfile = (props) => {

  // Hooks 
  const navigation = useNavigate();
  const styles = useStyles();

  // State
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [createEditMode, setCreateEditMode] = useState(false);
  const [userData, setUserData] = useState(userObj);
  const [allClasses, setAllClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);

  const [newEmail, setNewEmail] = useState('');
  const [multipleEmail, setMultipleEmail] = useState([]);
  const [newPhoneNo, setNewPhoneNo] = useState('');
  const [multiplePhoneNo, setMultiplePhoneNo] = useState([]);

  const [roleData, setRoleData] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmModalMsg, setConfirmModalMsg] = useState(false);
  const [confirmResetModal, setConfirmResetModal] = useState(false);

  const [validate, setValidate] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [errorEmailMessage, setErrorEmailMessage] = useState(null);
  const [errorPhoneMessage, setErrorPhoneMessage] = useState(null);

  const [stateSnackbar, setStateSnackbar] = useState({ open: false, vertical: 'bottom', horizontal: 'center' });
  const { vertical, horizontal, open } = stateSnackbar;
  const [snackbarMessage, setSnackbarMessage] = useState('');

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);
  const { paramsdata } = useSelector((state) => state.common);

  // React logic hooks
  useEffect(() => {
    console.log("useParams", paramsdata);
    const innerFun = async () => {
      let classData = await getClassNames(userInfo.site_uuid);
      setAllClasses(classData);

      if (paramsdata !== null) {
        setRoleData(paramsdata.rolesData);
        setValidate(true);
        if (paramsdata.userUid != null) {
          let userUid = paramsdata.userUid;
          let params = {
            query: {
              $limit: 1,
              'uid': [userUid],
              'site_uuid': userInfo.site_uuid
            }
          };
          let res = await fetchUserByUid(params);
          let resUserData = res.data.data[0];
          resUserData.name = joinByKeys(resUserData.name, ['firstname', 'middlename', 'lastname'], ' ')
          if (resUserData.contact_details != null && resUserData.contact_details != undefined) {
            setMultipleEmail(resUserData.contact_details.cdetails.email);
            setMultiplePhoneNo(resUserData.contact_details.cdetails.phone);
          }

          if (paramsdata.rolesData.title == 'learner') {
            let findObj = classData.filter((obj) => {
              return obj.id == resUserData.belongs_to
            });
            console.log("HHH", findObj[0]);
            setSelectedClass(findObj[0]);
            localStorage.setItem("selectedClassId",findObj[0].id);
          }
          setUserData(resUserData);
        }
        else {
          setSelectedClass(classData[0]);
          setIsCreateMode(true);
          setCreateEditMode(true);
        }
      }
    }
    innerFun();
  }, [paramsdata]);


  const copyText = (msg, txt) => {
    let inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = txt;
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    setSnackbarMessage(msg + ' Copied');
    setStateSnackbar({ ...stateSnackbar, open: true });
  };

  const handleClose = () => {
    setStateSnackbar({ ...stateSnackbar, open: false });
  };

  // Date change
  const DateChange = (date, valid, err, field) => {
    if (valid) {
      if (field == "joining_date") {
        setUserData({ ...userData, [field]: date });
      }
      if (field == "birthday") {
        setUserData({ ...userData, [field]: date });
      }
    }
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
  };

  // Validate name on blur
  const nameBlurValidate = () => {
    let validaten = validator({ required: true, value: userData.name });
    if (!validaten["validate"]) {
      setNameError(validaten["message"]);
      setValidate(false);
    } else {
      setNameError(null);
      setValidate(true);
    }
  };

  // Validate email on blur
  const emailBlurValidate = () => {
    if (newEmail) {
      let validatee = validator({
        pattern: `/^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/`,
        value: newEmail,
      });
      if (!validatee["validate"]) {
        setErrorEmailMessage(validatee["message"]);
        setValidate(false);
        return false;
      } else {
        setErrorEmailMessage(null);
        setValidate(true);
        return true;
      }
    } else {
      setErrorEmailMessage(null);
      setValidate(true);
      return false;
    }
  };


  // Validate phone on blur
  const phoneBlurValidate = () => {
    if (newPhoneNo) {
      let validatep;
      validatep = validator({
        pattern: `/^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im`,
        value: newPhoneNo,
      });
      if (!validatep["validate"]) {
        setErrorPhoneMessage(validatep["message"]);
        setValidate(false);
        return false;
      } else {
        setErrorPhoneMessage(null);
        setValidate(true);
        return true;
      }
    } else {
      setErrorPhoneMessage(null);
      setValidate(true);
      return false;
    }
  };


  const handleEmailDetail = () => {
    let isValidate = emailBlurValidate();
    if (isValidate) {
      let newData = [...multipleEmail];
      let resNewData = newData.filter((obj) => { return (obj.email_address == newEmail.trim()) });
      if (resNewData.length == 0) {
        let emailData = {
          "uuid": uuid(),
          "type": "self",
          "context": "",
          "email_address": newEmail.trim(),
          "email_verified": false,
          "default": false,
          "social": [],
          "notification_flag": false
        };
        setMultipleEmail([...multipleEmail, emailData]);
        setNewEmail('');
        setErrorEmailMessage(null);
        setValidate(true);
        return
      } else {
        setErrorEmailMessage('Duplicate e-mail not allowed');
        setValidate(false);
        return;
      }
    }
  };

  const handlePhoneDetail = () => {
    let isValidate = phoneBlurValidate();
    if (isValidate) {
      let newData = [...multiplePhoneNo];
      let resNewData = newData.filter((obj) => { return (obj.phone_number == newPhoneNo.trim()) });
      if (resNewData.length == 0) {
        let phoneData = {
          "uuid": uuid(),
          "type": "self",
          "context": "",
          "country": "IN",
          "country_code": "+91",
          "phone_number": newPhoneNo.trim(),
          "extention": "",
          "phone_verified": false,
          "default": false,
          "social": [],
          "notification_flag": false
        };
        setMultiplePhoneNo([...multiplePhoneNo, phoneData]);
        setNewPhoneNo('');
        setErrorPhoneMessage(null);
        setValidate(false);
        return
      } else {
        setErrorPhoneMessage('Duplicate phone number not allowed');
        setValidate(true);
        return;
      }
    }
  };

  const removeChip = (index, type) => {
    if (type == 'email') {
      let newData = [...multipleEmail];
      newData.splice(index, 1);
      setMultipleEmail(newData);
    } else if (type == 'phone_number') {
      let newData = [...multiplePhoneNo];
      newData.splice(index, 1);
      setMultiplePhoneNo(newData);
    }
  };

  const redirectTo = () => {
    if (isCreateMode) {
      navigation(`/Users`);
    } else {
      setCreateEditMode(false);
    }
  };

  // 
  const saveUserData = async () => {
    validateAllFunction();
    //console.log("userData=====>", userData);    

    if (validate) {
      let newUserData = userData;
      newUserData.name = nameToJson(newUserData.name);
      newUserData.site_uuid = userInfo.site_uuid;
      if (userData.contact_details != null) {
        newUserData.contact_details.cdetails.email = multipleEmail;
        newUserData.contact_details.cdetails.phone = multiplePhoneNo;
      } else {
        newUserData.contact_details = { "cdetails": { "email": multipleEmail, "phone": multiplePhoneNo, "email_notification_flag": false } }
      }
      // console.log("newUserData", newUserData);
      if (isCreateMode) {
        //console.log("IFFF");
        let webLogin = true;
        if (serverRole !== 'WEB_HOST') webLogin = false;
        let passcode = generateRandomId(8);
        let unm = userInfo.username.split("@");
        newUserData.role_uid = paramsdata.rolesData.uid;
        passcode += "@" + unm[1].toUpperCase();
        newUserData.passcode = passcode;
        newUserData.allowedweblogin = webLogin;
        let res = await createUser(newUserData);

        // insert log for user add
        let res1 = {};
        res1.oldValue = "";
        res1.newValue = newUserData; 

        let outcome = {};
        outcome.action = "add";
        outcome.value = res1;

        await userLogs({
          actor: userInfo.uid,
          verb: "user",
          target: res.response.uid,
          outcome: outcome,
          site_uuid: userInfo.site_uuid,
        });

        setConfirmModal(true);
        setConfirmModalMsg('User created!');
      } else {
        console.log("ELSE");
        let params = {
          query: {
            uid: newUserData.uid,
            site_uuid: newUserData.site_uuid
          }
        };
        await updateUsersAction(null, newUserData, params);

        // insert log for user edit
        let res1 = {};
        res1.oldValue = "";
        res1.newValue = newUserData.name;
        let outcome = {};
        outcome.action = "edit";
        outcome.value = res1;

        await userLogs({
          actor: userInfo.uid,
          verb: "user",
          target: newUserData.uid,
          outcome: outcome,
          site_uuid: userInfo.site_uuid,
        });

        setConfirmModal(true);
        setConfirmModalMsg('User updated!');
      }
      setTimeout(() => {
        navigation(`/Users`);
      }, 1500)
    }
  };

  const validateAllFunction = () => {
    nameBlurValidate();
  };

  const resetPassword = async() => {
    let newUserData = userData;
    let passcode = generateRandomId(8);
    let unm = userData.username.split("@");
    passcode += "@" + unm[1].toUpperCase();
    let updatedData = {
      password: '',
      passcode: passcode,
      is_synced: false
    }
    let params = {
      query: {
        uid: newUserData.uid,
        site_uuid: newUserData.site_uuid
      }
    };
    let res = await updateUsersAction(null, updatedData, params);
    setUserData({ ...userData, ['passcode']: res.data.passcode });
    setConfirmResetModal(false);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item xs={4} sx={{}}>
          <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Grid>
              <Box sx={{ textAlign: "center" }}>
                <Avatar
                  sx={{
                    width: 260, height: 260,
                    '@media (min-width: 1636px)': {
                      width: 300,
                      height: 300,
                    }
                  }}
                  src="/login.webp"
                ></Avatar>
              </Box>
            </Grid>
            <Grid>
              <Box sx={{ textAlign: "center", mt: 2 }}>
                {!createEditMode && (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      borderRadius: 15,
                      backgroundColor: "#FFFFFF",
                      border: 1,
                      borderColor: "#D9D9D9",
                      boxShadow: "0",
                      color: "primary.main",
                      height: "2rem",
                      textTransform: "inherit",
                     
                      '@media (min-width: 1636px)': {
                        height: '3rem',
                        width: '7rem'
                      }
                    }}
                    onClick={() => { setCreateEditMode(true) }}
                  >
                    <Typography sx={{
                      fontWeight: "500", fontSize: "0.9rem", '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }
                    }}>
                      Edit
                    </Typography>
                  </Button>
                )}
                {(createEditMode) && (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        borderRadius: 15,
                        backgroundColor: "#FFFFFF",
                        border: 1,
                        borderColor: "#D9D9D9",
                        boxShadow: "0",
                        color: "primary.main",
                        height: "2rem",
                        textTransform: "inherit",
                       
                        '@media (min-width: 1636px)': {
                          height: '3rem',
                          width: '7rem'
                        }
                      }}
                      onClick={redirectTo}
                    >
                      <Typography sx={{
                        fontWeight: "500", fontSize: "0.9rem", '@media (min-width: 1636px)': {
                          fontSize: '1.4rem'
                        }
                      }}>
                        Cancel
                      </Typography>
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        borderRadius: 15,
                        backgroundColor: "#FFFFFF",
                        border: 1,
                        borderColor: "#D9D9D9",
                        boxShadow: "0",
                        color: "primary.main",
                        height: "2rem",
                        textTransform: "inherit",
                        mx: 1,
                       
                        '@media (min-width: 1636px)': {
                          height: '3rem',
                          width: '7rem'
                        }
                      }}
                      onClick={() => { saveUserData() }}
                    >
                      <Typography sx={{
                        fontWeight: "500", fontSize: "0.9rem", '@media (min-width: 1636px)': {
                          fontSize: '1.4rem'
                        }
                      }}>
                        Save
                      </Typography>
                    </Button>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {
          userData &&
          <Grid item xs={8} sx={{ pr: 1, pt: 7 }} >
            <Box>
              <Grid container sx={{ justifyContent: 'space-around' }}>
                <Grid Item>
                  <Typography
                    sx={{
                      color: "#DB8829", fontSize: "0.9rem", fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }
                    }}
                  >
                    Name:
                  </Typography>
                  <TextField
                    size="small"
                    required
                    id="outlined-required"
                    sx={{
                      borderRadius: 50,
                    }}

                    InputProps={{
                      inputProps: {
                        sx: {
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          width: "30ch",
                          '@media (min-width: 1636px)': {
                            fontSize: '1.4rem',
                            width: "35ch"
                          }

                        },
                      },
                      sx: { borderRadius: 50 },
                    }}
                    name={"name"}
                    value={userData.name}
                    disabled={!createEditMode}
                    placeholder={"Enter Name"}
                    onChange={handleFormChange}
                    onBlur={() => { nameBlurValidate() }}
                    error={nameError}
                    helperText={nameError}
                  />
                </Grid>
                <Grid Item>
                  {roleData && roleData.title != 'learner' &&
                    <>
                      <Typography
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          pl: 2, '@media (min-width: 1636px)': {
                            fontSize: '1.4rem'
                          }
                        }}
                      >
                        Designation:
                      </Typography>
                      <TextField
                        size="small"
                        required
                        id="outlined-required"
                        sx={{
                          borderRadius: 50,
                        }}

                        InputProps={{
                          inputProps: {
                            sx: {
                              color: "#DB8829",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              width: "30ch",
                              '@media (min-width: 1636px)': {
                                fontSize: '1.4rem',
                                width: "35ch"
                              }

                            },
                          },
                          sx: { borderRadius: 50 },
                        }}
                        placeholder={"Enter Designation"}
                        name={"designation"}
                        value={userData.designation}
                        onChange={handleFormChange}
                        disabled={!createEditMode}
                      />
                    </>
                  }
                  {roleData && roleData.title == 'learner' && selectedClass &&
                    <>
                      <Typography
                        sx={{
                          color: "#DB8829", fontSize: "0.9rem", fontWeight: "500",
                          pl: 2, '@media (min-width: 1636px)': {
                            fontSize: '1.4rem'
                          }
                        }}
                      >
                        Class:
                      </Typography>
                      <DropdownComponent
                        minWidth={310}
                        defaultSelected={selectedClass}
                        dropDownData={allClasses}
                        fetchBySelectedValue={
                          (classId) => {
                            setUserData({ ...userData, ["belongs_to"]: classId })
                          }
                        }
                        disableVal={!createEditMode}
                      />
                    </>
                  }
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container sx={{ justifyContent: 'space-around' }}>
                <Grid Item>
                  <Typography
                    sx={{
                      marginTop: 5,
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }
                    }}
                  >
                    Email ID:
                  </Typography>
                  <TextField
                    size="small"
                    required
                    id="outlined-required"
                    sx={{
                      borderRadius: 50,
                    }}

                    InputProps={{
                      inputProps: {
                        sx: {
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          width: "30ch",
                          '@media (min-width: 1636px)': {
                            fontSize: '1.4rem',
                            width: "35ch"
                          }

                        },
                      },
                      sx: { borderRadius: 50 },
                    }}
                    value={newEmail}
                    onInput={(event) => { setNewEmail(event.target.value) }}
                    onBlur={() => { emailBlurValidate() }}
                    onKeyDown={(event) => { if (event.keyCode === 13) { handleEmailDetail() } }}
                    disabled={!createEditMode}
                    placeholder={"Enter Email ID"}
                    error={errorEmailMessage}
                    helperText={errorEmailMessage}
                  />
                  <Box sx={{ textAlign: 'left', display: 'table-caption' }}>
                    {
                      multipleEmail.map((item, index) => {
                        return (
                          <Chip
                            sx={{ mx: 1, mt: 1, fontSize: '0.8rem', backgroundColor: '#F5F5F5', color: 'primary.main', fontWeight: '500' }}
                            label={item.email_address}
                            disabled={!createEditMode}
                            onDelete={() => { removeChip(index, 'email') }}
                            deleteIcon={<CloseIcon />}
                            size="small" />
                        )
                      })
                    }
                  </Box>
                </Grid>
                <Grid Item>
                  <Typography
                    sx={{
                      marginTop: 5,
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }
                    }}
                  >
                    Phone no:
                  </Typography>
                  <TextField
                    size="small"
                    required
                    id="outlined-required"
                    sx={{
                      borderRadius: 50,
                    }}

                    InputProps={{
                      inputProps: {
                        sx: {
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          width: "30ch",
                          '@media (min-width: 1636px)': {
                            fontSize: '1.4rem',
                            width: "35ch"
                          }

                        },
                      },
                      sx: { borderRadius: 50 },
                    }}
                    placeholder={"Enter Phone no:"}
                    disabled={!createEditMode}
                    value={newPhoneNo}
                    onInput={(event) => { setNewPhoneNo(event.target.value) }}
                    onBlur={() => { phoneBlurValidate() }}
                    onKeyDown={(event) => { if (event.keyCode === 13) { handlePhoneDetail() } }}
                    error={errorPhoneMessage}
                    helperText={errorPhoneMessage}

                  />
                  <Box sx={{ textAlign: 'left', display: 'table-caption' }}>
                    {
                      multiplePhoneNo.map((item, index) => {
                        return (
                          <Chip
                            sx={{ mx: 1, mt: 1, fontSize: '0.8rem', backgroundColor: '#F5F5F5', color: 'primary.main', fontWeight: '500' }}
                            label={item.phone_number}
                            disabled={!createEditMode}
                            onDelete={() => { removeChip(index, 'phone_number') }}
                            deleteIcon={<CloseIcon />}
                            size="small" />
                        )
                      })
                    }
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container sx={{ justifyContent: 'space-around' }}>
                <Grid Item>
                  <Typography
                    sx={{
                      marginTop: 5,
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }
                    }}
                  >
                    User Name:
                  </Typography>
                  <TextField
                    size="small"
                    required
                    id="outlined-required"
                    sx={{
                      borderRadius: 50,
                    }}

                    InputProps={{
                      inputProps: {
                        sx: {
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          width: "30ch",
                          '@media (min-width: 1636px)': {
                            fontSize: '1.4rem',
                            width: "35ch"
                          }

                        },
                      },
                      sx: { borderRadius: 50 },
                    }}
                    placeholder={"Enter Username"}
                    name={"username"}
                    value={userData.username}
                    disabled={true}
                  />
                  <Box sx={{ ml: 2, mt: 0.5 }}>
                    <Link href="#" variant="body2" sx={{ fontWeight: '500' }} onClick={() => { copyText('Username', userData.username) }} >Copy To Clipboard</Link>
                  </Box>
                </Grid>
                <Grid Item>
                  {
                    userData.passcode !== "" && userData.passcode !== undefined && userData.passcode !== null &&
                    <>
                      <Typography
                        sx={{
                          marginTop: 5,
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          pl: 2, '@media (min-width: 1636px)': {
                            fontSize: '1.4rem'
                          }
                        }}
                      >
                        Passcode:
                      </Typography>
                      <TextField
                        size="small"
                        required
                        id="outlined-required"
                        sx={{
                          borderRadius: 50,
                        }}

                        InputProps={{
                          inputProps: {
                            sx: {
                              color: "#DB8829",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              width: "30ch",
                              '@media (min-width: 1636px)': {
                                fontSize: '1.4rem',
                                width: "35ch"
                              }

                            },
                          },
                          sx: { borderRadius: 50 },
                        }}
                        name={"passcode"}
                        value={userData.passcode}
                        disabled={!createEditMode}
                        placeholder={"Enter Passcode"}
                      />
                      <Box sx={{ ml: 1, mt: 0.5 }}>
                        <Link href="#" variant="body2" sx={{ fontWeight: '500', pl: 1 }} onClick={() => { copyText('Passcode', userData.passcode) }} >Copy Passcode</Link>
                      </Box>
                    </>
                  }
                  {
                    (userData.passcode === "" || userData.passcode === undefined || userData.passcode === null) &&
                    <>
                      <Typography
                        sx={{
                          marginTop: 5,
                          color: "#DB8829",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          pl: 2, '@media (min-width: 1636px)': {
                            fontSize: '1.4rem',

                          }
                        }}
                      >
                        Password:
                      </Typography>
                      <TextField
                        size="small"
                        required
                        id="outlined-required"
                        sx={{
                          borderRadius: 50,

                        }}
                        InputProps={{
                          inputProps: {
                            sx: {
                              fontSize: "0.8rem",
                              color: "#DB8829",
                              fontWeight: "500",
                              width: "30ch",
                              pl: 2, '@media (min-width: 1636px)': {
                                fontSize: '1.4rem',
                                width: "35ch"
                              }
                            },
                          },
                          style: { borderRadius: 50 },
                        }}
                        placeholder={"Password"}
                        value={"*************"}
                        disabled={true}
                      />
                      <Box sx={{ ml: 1, mt: 0.5 }}>
                        <Link variant="body2" sx={{
                          fontWeight: '500',
                          cursor: 'pointer',
                          pl: 1, '@media (min-width: 1636px)': {
                            fontSize: '1.4rem'
                          }}} 
                          onClick={() => { setConfirmResetModal(true); }}
                        >Reset Password</Link>
                      </Box>
                    </>
                  }
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container sx={{ justifyContent: 'space-around' }}>
                <Grid Item>
                  <Typography
                    sx={{
                      marginTop: 5,
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem',
                        width: '35ch'
                      }
                    }}
                  >
                    Birth Date:
                  </Typography>
                  <WwDatePicker
                    dateChange={({ date, valid, errorMessage }) =>
                      DateChange(date, valid, errorMessage, "birthday")
                    }
                    maxDate={Date.now()}
                    defaultDate={userData.birthday}
                    disabled={!createEditMode}
                  ></WwDatePicker>
                </Grid>
                <Grid Item>
                  <Typography
                    sx={{
                      marginTop: 5,
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      pl: 2, '@media (min-width: 1636px)': {
                        fontSize: '1.4rem',
                        width: '35ch'
                      }
                    }}
                  >
                    Joining Date:
                  </Typography>
                  <WwDatePicker
                    dateChange={({ date, valid, errorMessage }) =>
                      DateChange(date, valid, errorMessage, "joining_date")
                    }
                    maxDate={Date.now()}
                    defaultDate={userData.joining_date}
                    disabled={!createEditMode}
                  ></WwDatePicker>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container sx={{ justifyContent: 'flex-start' }}>
                <Grid Item>
                  <FormControl>
                    <FormLabel
                      sx={{
                        marginTop: 5,
                        color: "#DB8829",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        pl: 2,
                        ml: 8, '@media (min-width: 1636px)': {
                          fontSize: '1.4rem'

                        }
                      }}
                    >
                      Gender
                    </FormLabel>
                    <RadioGroup
                      name="gender"
                      value={userData.gender}
                      onChange={handleFormChange}
                      row={true}
                      sx={{ ml: 8 }}
                    >
                      <FormControlLabel
                        value="Female"
                        control={<Radio checked={userData.gender === 'Female'} />}
                        label={<Typography sx={{ color: '#cccccc', fontSize: '1vw' }}>Female</Typography>}
                        disabled={!createEditMode}
                      />
                      <FormControlLabel
                        value="Male"
                        control={<Radio checked={userData.gender === 'Male'} />}
                        label={<Typography sx={{ color: '#cccccc', fontSize: '1vw' }}>Male</Typography>}
                        disabled={!createEditMode}
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Radio checked={userData.gender === 'Other'} />}
                        label={<Typography sx={{ color: '#cccccc', fontSize: '1vw' }}>Other</Typography>}
                        disabled={!createEditMode}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        }
      </Grid>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
        key={vertical + horizontal}
        ContentProps={{
          classes: {
            root: styles.root
          }
        }}
        sx={{ top: { xs: 90, sm: 0 } }}
      />
      <Confirmation
        visible={confirmModal}
        primaryText={confirmModalMsg}
        image="complete"
        alert={true}
        toggleModal={(flag) => setConfirmModal(flag)}
        timeout={2000}
      ></Confirmation>
      <Confirmation
        image="delete"
        primaryText="Do you want to reset it?"
        visible={confirmResetModal}
        positiveClick={resetPassword}
        negativeClick={() => { setConfirmResetModal(false) }}
        toggleModal={(flag) => setConfirmResetModal(flag)}
        persistent={true}
      ></Confirmation>
    </Box>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: '1rem !important'
  },
  scrollBar: {
    '&::-webkit-scrollbar': {
      width: '0.2em'
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      borderRadius: 5
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5
    }
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: '0.2em'
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      borderRadius: 5
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5
    }
  },
})

export default UserProfile;
